import Vue from 'vue'
import Router from 'vue-router'

const components = {
  /** 随app.[hash].js一起打包 */
  index: require('../pages/pc/index.vue').default,

  /** 代码分割式打包 */
  sqsy: () => import('../pages/pc/sqsy.vue'),
  swhz: () => import('../pages/pc/swhz.vue')
}

Vue.use(Router)

export default new Router({
  routes: Object.keys(components).map(key => {
    return {
      path: key === 'index' ? '/' : '/' + key,
      name: key,
      component: components[key]
    }
  })
})
